import React from 'react';

import pluralize from 'pluralize';

import { useSelector } from 'bundles/research/index/store/hooks';

import NewPropertyButton from 'bundles/research/index/properties/new/button';
import PropertiesActionDropdown from 'bundles/research/index/properties/properties_action_dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildings } from '@fortawesome/pro-regular-svg-icons';
import PageHeader from 'components/ui/page_header';
import { inOsNavShell } from 'components/buildout_os_display';

export default function PropertiesIndexHeaderEdgeCrm() {
  const currentTab = useSelector(state => state.ui.currentTab);
  const importerProps = useSelector(state => state.importerProps);
  const insights = useSelector(state => state.features.insights);
  const newPropertyPath = useSelector(state => state.paths.newProperty);
  const totalCount = useSelector(state => state.search.meta.totalCount);
  const count = currentTab !== 'maps' && pluralize('Property', totalCount, true);
  const actions = (
    <>
      <PropertiesActionDropdown />
      <NewPropertyButton
        edgeCrm
        importerProps={importerProps}
        insights={insights}
        newPropertyPath={newPropertyPath}
      />
    </>
  );

  if (inOsNavShell()) {
    return (
      <PageHeader band>
        <PageHeader.Heading description={count} title="Properties" />
        <PageHeader.Actions>{actions}</PageHeader.Actions>
      </PageHeader>
    );
  }

  return (
    <div className="bg-card d-flex align-items-center border-bottom p-4 shadow">
      <div className="d-flex flex-fill gap-2 align-items-stretch">
        <div className="align-self-center">
          <FontAwesomeIcon icon={faBuildings} size="xl" />
        </div>
        <h4 className="align-self-center">Properties</h4>
        {count && (
          <div className="d-none d-lg-flex text-muted ms-4 border-start ps-4 align-items-center">
            {count}
          </div>
        )}
      </div>

      <div className="d-flex align-items-center gap-2">
        {actions}
      </div>
    </div>

  );
}
